import React from "react";

import {
  Link,
} from "react-router-dom";

import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaArrowRight,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

import "../styles/Footer.css";

const Footer = () => {

  const handleSubscribe = (e) => {

    e.preventDefault();

    const email =
      e.target.elements.email.value;

    if (email) {

      alert(
        `Thanks for subscribing, ${email}! 🚴`
      );

      e.target.reset();
    }
  };

  return (

    <footer className="footer">

      {/* TOP */}

      <div className="footer-container">

        {/* BRAND */}

        <div className="footer-brand">

          <Link
            to="/"
            className="footer-logo"
          >

            <img
              src="https://i.ibb.co/MwHMzcZ/Whats-App-Image-2025-08-05-at-10-30-04-AM-removebg-preview.png"
              alt="SAC MTB Logo"
            />

            <h2>

              SAC
              <span> MTB</span>

            </h2>

          </Link>

          <p>

            Premium bicycles and luxury
            ride-on toys crafted for
            adventure, excitement,
            and unforgettable rides.

          </p>

          {/* CONTACT */}

          <div className="footer-contact">

            <div>

              <FaMapMarkerAlt />

              <span>
                India
              </span>

            </div>

            <div>

              <FaPhoneAlt />

              <span>
                +91 6396353776
              </span>

            </div>

            <div>

              <FaEnvelope />

              <span>
                support@sacmtb.com
              </span>

            </div>

          </div>

        </div>

        {/* QUICK LINKS */}

        <div className="footer-links">

          <h3>
            Quick Links
          </h3>

          <ul>

            <li>
              <Link to="/">
                Home
              </Link>
            </li>

            <li>
              <Link to="/productspage">
                Products
              </Link>
            </li>

            <li>
              <Link to="/about">
                About Us
              </Link>
            </li>

            <li>
              <Link to="/contactpage">
                Contact
              </Link>
            </li>

          </ul>

        </div>

        {/* SUPPORT */}

        <div className="footer-links">

          <h3>
            Support
          </h3>

          <ul>

            <li>
              <Link to="/faqs">
                FAQs
              </Link>
            </li>

            <li>
              <Link to="/shipping">
                Shipping
              </Link>
            </li>

            <li>
              <Link to="/returns">
                Returns
              </Link>
            </li>

            <li>
              <Link to="/privacy-policy">
                Privacy Policy
              </Link>
            </li>

            <li>
              <Link to="/terms">
                Terms & Conditions
              </Link>
            </li>

          </ul>

        </div>

        {/* NEWSLETTER */}

        <div className="footer-newsletter">

          <h3>
            Stay Connected
          </h3>

          <p>

            Subscribe for latest product launches,
            premium rides, offers, and updates.

          </p>

          {/* FORM */}

          <form
            className="newsletter-input"
            onSubmit={handleSubscribe}
          >

            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              required
            />

            <button type="submit">

              Subscribe

              <FaArrowRight />

            </button>

          </form>

          {/* SOCIALS */}

          <div className="footer-socials">

            <a
              href="https://www.facebook.com/share/1HoANsoczL/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >

              <FaFacebookF />

            </a>

            <a
              href="https://instagram.com/sacmtb/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >

              <FaInstagram />

            </a>

            <a
              href="https://youtube.com/channel/UCcVO0VcUyXE7MAhWMz4H5Ow"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >

              <FaYoutube />

            </a>

          </div>

        </div>

      </div>

      {/* BOTTOM */}

      <div className="footer-bottom">

        <p>

          © {new Date().getFullYear()}
          {" "}
          SAC INTERNATIONAL.
          All Rights Reserved.

        </p>

      </div>

    </footer>
  );
};

export default Footer;